<template>
  <modal @close="$emit('close')">
    <template slot="header">
      AWS account -
      <template v-if="form._id">edit</template>
      <template v-if="!form._id">add new</template>
    </template>
    <div class="alert alert-primary">
      In order to properly setup AWS account you need to make sure that the
      provided API keys have a proper access roles to setup necessary resources
      for SNS and SES services.<br />
      Go to
      <a style="color: #2196f3" target="_blank"
        href="https://us-east-1.console.aws.amazon.com/iamv2/home?region=us-east-1&skipRegion=true#/home"><strong>IAM
          console</strong></a>
      -> <strong>Users</strong> -> Select username for which you are trying to
      add access -> Make sure you are on "<strong>Permission</strong>" tab.<br />
      In section "<strong>Permissions policies</strong>" click "<strong>Add permissions</strong>" then select
      "<strong>Attach existing policies directly</strong>". From
      the list select two items: "<strong>AmazonSESFullAccess</strong>" and
      "<strong>AmazonSNSFullAccess</strong>", then click "<strong>Next: Review</strong>" add the bottom then follow to
      "<strong>Add Permissions</strong>".<br />
      Watch a short video tutorial <a href="/static/IAM.webm">here</a>
    </div>
    <fieldset class="mb-3" :class="{ 'loading-mask': loading }">
      <div class="form-group row">
        <label class="col-form-label col-lg-2">Account name</label>
        <div class="col-lg-4">
          <input type="text" class="form-control" v-model="form.name" />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-form-label col-lg-2">Api key</label>
        <div class="col-lg-4">
          <input type="text" class="form-control" v-model="form.api_key" />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-form-label col-lg-2">Api secret</label>
        <div class="col-lg-4">
          <input type="text" class="form-control" v-model="form.api_secret" />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-form-label col-lg-2">Rate limit (num. of messages sent per second, assigned by AWS)</label>
        <div class="col-lg-4">
          <input type="text" class="form-control" v-model="form.limit_per_second" />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-form-label col-lg-2">24h limit (assigned by AWS)</label>
        <div class="col-lg-4">
          <input type="text" class="form-control" v-model="form.limit_per_24h" />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-form-label col-lg-2">Manual limit of messages per 24h</label>
        <div class="col-lg-4">
          <input type="text" class="form-control" v-model="form.manual_limit_per_24h" />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-form-label col-lg-2">Automatic resume limit
          <br /><small>Once send in last 24h drops below this number the account will be resumed. It works only when
            "Manual
            limit
            of messages per 24h" is set</small>
        </label>
        <div class="col-lg-4">
          <input type="text" class="form-control" v-model="form.manual_limit_resume_quota" />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-form-label col-lg-2">AWS region</label>
        <div class="col-lg-4">
          <input type="text" class="form-control" v-model="form.aws_region" />
        </div>
        <div class="alert alert-primary">
          AWS Regions:
          {{
            [
              "us-west-1",
              "us-west-2",
              "eu-west-1",
              "eu-west-2",
              "eu-central-1",
              "ap-southeast-1",
              "ap-southeast-2",
              "ap-northeast-1",
              "ap-northeast-2",
              "sa-east-1",
              "cn-north-1",
              "us-east-1",
            ].join(", ")
          }}
        </div>
      </div>
      <div class="form-group row">
        <label class="col-form-label col-lg-2">Use IP</label>
        <div class="col-lg-4">
          <select class="form-control" v-model="form.use_ip">
            <option></option>
            <option v-for="ip in ips" :value="ip.ip">{{ ip }}</option>
          </select>
        </div>
      </div>
      <div class="alert alert-danger" v-if="err">{{ err }}</div>
      <div class="form-group row">
        <label class="col-form-label col-lg-12">
          <button type="button" class="btn btn-primary" @click="save(false)">
            Save and test API
          </button>
          <button type="button" class="btn btn-primary" @click="save(true)" v-if="form._id">
            Save only settings
          </button>
          <button class="btn btn-link" @click="$emit('close')">Cancel</button>
        </label>
      </div>
    </fieldset>
  </modal>
</template>
<script>
import modal from "../common/Modal.vue";

export default {
  components: { modal },
  props: {
    obj: null,
    domains: [],
  },
  data() {
    return {
      form: {
        _id: null,
        name: null,
        api_key: null,
        api_secret: null,
        aws_region: "us-east-1",
        limit_per_second: 0,
        limit_per_24h: 0,
        use_ip: null,
        webhook_domain: null,
      },
      ips: [],
      err: null,
      loading: false,
      check_api: true,
    };
  },
  methods: {
    save(skipCheck) {
      if (!this.check_api || skipCheck) {
        return this._save(skipCheck);
      }

      this.loading = true;
      this.$api
        .postReq("test_api_access", {
          provider: "aws",
          api_key: this.form.api_key,
          api_secret: this.form.api_secret,
          aws_region: this.form.aws_region,
          use_ip: this.form.use_ip
        })
        .then((res) => {
          this._save();
        })
        .catch((res) => {
          this.err = "Cannot connect to API, invalid API keys";
          this.loading = false;
        });
    },
    _save(skipCheck) {
      this.loading = true;
      this.$api
        .postReq("accounts/aws" + (skipCheck ? "?skip_setup=true" : ""), this.form)
        .then((res) => {
          this.$emit("close");
          this.$emit("reload");
        })
        .catch((res) => {
          this.loading = false;
          this.err = res.body.error;
        });
    },
  },
  mounted() {
    console.log(this.domains);
    this.loading = true;
    this.$api.getReq("status/ipaddresses").then((res) => {
      this.ips = res.body.ips;
      this.loading = false;
    });

    if (this.obj !== true) {
      this.form = this.obj;
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/modal/Aws.vue